import idealdisc from 'assets/images/ats/integrations/logos/idealdisc.svg'
import linkedin from 'assets/images/ats/integrations/logos/linkedin.svg'
import whatsapp from 'assets/images/ats/integrations/logos/whatsapp.svg'
import wttjLogo from 'assets/images/ats/integrations/logos/wttj.svg'

import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'

import {
  AtsAppTypeIds,
  AtsIntegrationTypeIds,
  type IntegrationData,
  type MarketplaceIntegrationData,
} from 'modules/ats/types/integrations'
import { WELCOME_TO_THE_JUNGLE_ID } from 'modules/marketplace/lib/integrationIds'

const ATS_SUSCRIPTION_ADDONS = [
  ...Object.values(AtsAppTypeIds),
  ...Object.values(AtsIntegrationTypeIds),
]

export const isAtsSuscriptionAddon = (suscriptionAddonId: AtsAppTypeIds | AtsIntegrationTypeIds) =>
  ATS_SUSCRIPTION_ADDONS.includes(suscriptionAddonId)

export const isAtsSuscriptionAddonEnabled = (integrationData?: IntegrationData[number]) =>
  integrationData && (!integrationData.feature || hasFeature(integrationData.feature!))

export const marketplaceIntegrations = (): MarketplaceIntegrationData[] => [
  {
    name: 'Welcome to the Jungle',
    marketplaceId: WELCOME_TO_THE_JUNGLE_ID,
    imageUrl: wttjLogo,
    enabled: true,
    description: i18n.t('ats.settings.integrations.providers.welcome_to_the_jungle.description'),
  },
]

export const atsPromoteJobsAddons = (): IntegrationData => ({
  [AtsAppTypeIds.LinkedinLimitedListings]: {
    id: AtsAppTypeIds.LinkedinLimitedListings,
    title: 'LinkedIn Limited Listings',
    description: i18n.t('app_store_v2.app_integrations.linkedin_limited_listings.description'),
    image: {
      src: linkedin,
      alt: 'LinkedIn',
    },
  },
})

export const atsOtherAddons = (): IntegrationData => ({
  [AtsAppTypeIds.AtsIdealDiscIntegration]: {
    id: AtsAppTypeIds.AtsIdealDiscIntegration,
    title: 'IdealDisc',
    description: i18n.t('app_store_v2.app_integrations.dev_ats_ideal_disc_integration.description'),
    image: {
      src: idealdisc,
      alt: 'IdealDISC',
    },
  },
  [AtsAppTypeIds.AtsWhatsapp]: {
    id: AtsAppTypeIds.AtsWhatsapp,
    title: i18n.t('app_store_v2.app_integrations.ats_whatsapp.title'),
    description: i18n.t('app_store_v2.app_integrations.ats_whatsapp.description'),
    image: {
      src: whatsapp,
      alt: 'WhatsApp',
    },
  },
})
